import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyBYvkT3fZWdcQxZhMyjRZ4FqrJXATFtjkM",
  authDomain:        "litislab-ab9ef.firebaseapp.com",
  projectId:         "litislab-ab9ef",
  storageBucket:     "litislab-ab9ef.firebasestorage.app",
  messagingSenderId: "195271489199",
  appId:             "1:195271489199:web:7191f62650290f3052065a",
  measurementId:     "G-BM93F7FX8H",
};

const firebaseApp    = initializeApp(firebaseConfig);
export const auth           = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
